const globalActions = {
  edit: "Edit",
  add: "Add",
  save: "Save",
  cancel: "Cancel",
  approve: "Approve",
  discard: "Discard",
  addNew: "Add New",
  yes: "Yes",
  no: "No",
  next: "Next",
  ok: "Ok",
  update: "Update",
  updating: "Updating...",
  remove: "Remove",
  backToCase: "Back to case",
  back: "Back",
  backToHome: "Back to Home",
  clearSearch: "Clear search",
  upload: "Upload",
  uploading: "Uploading...",
  delete: "Delete",
  moveUp: "Move Up",
  moveDown: "Move Down",
  viewOrDownload: "View/Download",
  copyToClipboard: "Copy to Clipboard",
  post: "Post",
  apply: "Apply",
  confirm: "Confirm",
  refresh: "Refresh",
  preview: "Preview",
  reload: "Reload",
  optionDefault: "Please Select",
  uploadNewDocument: "Upload New Document",
  login: "Login",
  export: "Export",
  extendSession: "Extend session",
  clickHere: "click here",
  logOutNow: "Log out now",
  backTo: "Back to {{pageName}}",
  loginOut: "Logging out...",
  selectOption: "Select an option",
  select: "Select",
  prefixOptionsListLabels: {
    mr: "Mr.",

    ms: "Ms.",

    mrs: "Mrs.",

    miss: "Miss.",

    estateof: "Estate of",

    other: "Other",
  },
  showAttributesWithValues:"Filter Attributes with Values",
};

export default globalActions;
